// extracted by mini-css-extract-plugin
export default {"NewsImgs":"index_NewsImgs_-9aM5"};